import { CloseOutlined } from '@ant-design/icons'
import { Card, Flex, Space, Typography } from 'antd'


const { Text } = Typography


const getErrorMessageText = () => {
  const defaultMessage = 'Something went wrong...'
  return defaultMessage
}

export const Error = ({ errors }: any) => {
  return (
    <div>
      <Space direction='vertical' size='middle' style={{ display: 'flex' }}>
          <Card>
            <Flex align='center' gap='middle'>
              <CloseOutlined style={{ color: 'var(--critical-red)', fontSize: '2.5rem' }} />
              <Flex vertical>
                <Text>{getErrorMessageText()}</Text>
              </Flex>
            </Flex>
          </Card>
      </Space>
    </div>
  )
}
